import { removeStorageItems } from 'app/adapters/storage';
import { resolveAppPath } from 'app/utils/app-path';
import { FLEET_EMBED_STORAGE_KEY } from 'app/utils/fleet-embed';
import { removeVtOnBehalfOfCookie } from 'app/utils/vt-on-behalf-of';

/**
 * CanJS-parity Fleet iframe logout: drop bearer auth, then hard-navigate to
 * Spring logout so the browser clears HttpOnly JSESSIONID (VIS-10170).
 *
 * Uses assign (not replace) so a failed logout URL is easier to inspect in
 * DevTools Network / Sources without looking like a mysterious debugger pause.
 */
export function performFleetEmbedLogout() {
  console.log('[ELD] Performing Fleet embed logout (nav to Spring logout)');
  removeVtOnBehalfOfCookie();
  window.sessionStorage.removeItem('authToken');
  window.sessionStorage.removeItem(FLEET_EMBED_STORAGE_KEY);
  removeStorageItems(['token', 'isAuthUser', 'xClientIdentifier']);
  window.localStorage.removeItem('i18nextLng');
  const logoutUrl = resolveAppPath('/j_spring_cas_security_logout');
  console.log('[ELD] Navigating to', logoutUrl);
  window.location.assign(logoutUrl);
}
